(function () {
  'use strict';

  angular.module('sempraWebapp').provider('api', apiProvider);

  /** @ngInject */
  function apiProvider () {
    this.$get = ['useServerMock', 'apiService', 'apiMockService', 'hostProtocol', 'hostDomain', 'useRemoteServerConnection',
      function (useServerMock, apiService, apiMockService, hostProtocol, hostDomain, useRemoteServerConnection) {
        if (useServerMock) {
          return apiMockService;
        }

        if (useRemoteServerConnection) {
          apiService.init(hostProtocol + '://' + hostDomain);
        }

        return apiService;
      }];
  }
})();
